<span class="version-text"> Graam version {{ appVersion }} ( built {{buildDate}} - {{ versionSHA }} )</span>

<div fxLayout="row" fxLayoutAlign="end center" class="top-margin" *ngIf="autoUpdate.updateAvailable">
  <button mat-button (click)="autoUpdate.startDownloading()">
    {{'auto_update.actions.download' | translate }}
  </button>
</div>
<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
  <div fxFlex fxFlex.xs="auto" class="top-margin">
    <span>{{'public.lang' | translate }}</span>
  </div>
  <div fxFlex fxFlex.xs="30">
    <mat-form-field class="full-width">
      <mat-select [formControl]="appLanguage" interface="popover">
        <mat-option *ngFor="let language of languages" [value]="language.code">
          {{ language.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>

<mat-divider class="top-margin"></mat-divider>
<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
  <div fxFlex fxFlex.xs="auto" class="top-margin">
    <span>{{ 'components.settings.should_enable_sipstack'|translate }}</span>
  </div>
  <div fxFlex fxFlex.xs="30" class="end">
    <mat-slide-toggle [(ngModel)]="sipstackEnabled" color="primary" (change)="setSipstackMode()"></mat-slide-toggle>
  </div>
</div>
<mat-divider class="top-margin"></mat-divider>
<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
  <div fxFlex fxFlex.xs="auto" class="top-margin">
    <span>{{ 'components.settings.instant_dial'|translate }}</span>
  </div>
  <div fxFlex fxFlex.xs="30" class="end">
    <mat-slide-toggle [(ngModel)]="hotkeyConfig.instant_dial" color="primary" (change)="updateHotkeyConfig()">
    </mat-slide-toggle>
  </div>
</div>
<mat-divider class="top-margin"></mat-divider>
<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
  <div fxFlex fxFlex.xs="auto" class="top-margin">
    <span>{{ 'components.settings.open_bo_on_call'|translate }}</span>
  </div>
  <div fxFlex fxFlex.xs="30" class="end">
    <mat-slide-toggle [formControl]="openBoOnCallCtrl" color="primary">
    </mat-slide-toggle>
  </div>
</div>
<div *ngIf="openBoOnCallCtrl.value" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
  <div fxFlex fxFlex.xs="auto">
    <span>{{'components.settings.position_iframe' | translate }}</span>
  </div>
  <div fxFlex fxFlex.xs="30">
    <mat-form-field class="full-width">
      <mat-select [formControl]="iframePositionCtrl" interface="popover">
        <mat-option *ngFor="let position of boIframePositions" [value]="position.value">
          {{ position.label | translate }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>

<mat-divider class="top-margin"></mat-divider>
<div fxLayout="column">
  <h2>{{'components.settings.audio_device_setting'|translate}}</h2>
  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
    <div fxFlex>
      <span>{{'components.settings.change_audio_device_setting'|translate}}</span>
    </div>
    <div fxFlex="40px">
      <button mat-icon-button (click)="changeAudioDeviceSettings()">
        <mat-icon>volume_up</mat-icon>
      </button>
    </div>
  </div>
</div>

<mat-divider class="top-margin"></mat-divider>
<ng-container *ngIf="isElectron">
  <div class="top-margin" *ngIf="devMode">
    <user-voice-mail [user]="currentUser"></user-voice-mail>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px" *ngIf="autoLaunchAvailable">
    <div fxFlex fxFlex.xs="auto" class="top-margin">
      <span>{{ 'components.settings.auto_launch_enable'|translate }}</span>
    </div>
    <div fxFlex fxFlex.xs="30" class="end">
      <mat-slide-toggle [(ngModel)]="autoLaunchEnable" (change)="changeAutoLaunchState()" color="primary">
      </mat-slide-toggle>
    </div>
  </div>
  <mat-divider class="top-margin"></mat-divider>
  <div fxLayout="column">
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
      <div fxFlex fxFlex.xs="auto" class="top-margin">
        <h2>{{ 'components.settings.hotkey_status'|translate }}</h2>
      </div>
      <div fxFlex fxFlex.xs="30" class="end">
        <mat-slide-toggle [(ngModel)]="hotkeyConfig.status" color="primary" (change)="updateHotkeyConfig()">
        </mat-slide-toggle>
      </div>
    </div>
    <ng-container *ngIf="hotkeyConfig.status">
      <div class="py-1">{{ 'components.settings.hotkey_description'|translate }}</div>
      <div fxFlex fxLayout="row" fxLayoutAlign="start center" *ngIf="hotkeyConfig.status">
        <div class="meta-key">
          <mat-form-field class="full-width">
            <mat-select [(ngModel)]="hotkeyConfig.meta_key" (selectionChange)="updateHotkeyConfig()">
              <mat-option value="control">Control</mat-option>
              <mat-option value="command" *ngIf="isOnMacOS">Command</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="px-1">+</div>
        <div class="event-key">
          <mat-form-field class="full-width">
            <input class='full-width' matInput type="text" [value]="getSymbol(hotkeyConfig.event_key)"
              (keydown)="setHotkeyConfigEventKey($event)" class="text-center">
          </mat-form-field>
        </div>
      </div>
    </ng-container>
  </div>
  <mat-divider class="top-margin"></mat-divider>
  <div fxLayout="column">
    <h2>{{ 'components.settings.newcall_script'|translate }}</h2>
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
      <div fxFlex>
        <span>{{ 'components.settings.inbound_script'|translate }}</span>
      </div>
      <div fxFlex class="end">
        <mat-slide-toggle [(ngModel)]="execScriptConfig.inbound" color="primary" (change)="updateExecScriptConfig()">
        </mat-slide-toggle>
      </div>
    </div>
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
      <div fxFlex>
        <span>{{ 'components.settings.outbound_script'|translate }}</span>
      </div>
      <div fxFlex class="end">
        <mat-slide-toggle [(ngModel)]="execScriptConfig.outbound" color="primary" (change)="updateExecScriptConfig()">
        </mat-slide-toggle>
      </div>
    </div>
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
      <div fxFlex="30">
        <span>{{ 'components.settings.script'|translate }}</span>
      </div>
      <div fxFlex>
        <mat-form-field class="full-width">
          <input class='full-width' matInput type="text" [(ngModel)]="execScriptConfig.script_path"
            (change)="updateExecScriptConfig()">
        </mat-form-field>
      </div>
    </div>

  </div>
  <mat-divider class="top-margin"></mat-divider>
  <div fxLayout="column">
    <h2>{{ 'components.settings.experimental'|translate }}</h2>
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
      <div fxFlex="30">
        <span>{{ 'components.settings.vocal_command_url' | translate }}</span>
      </div>
      <div fxFlex>
        <mat-form-field class="full-width">
          <input class='full-width' matInput type="text" [(ngModel)]="vocalCommandUrl" (change)="setVocalCommandUrl()">
        </mat-form-field>
      </div>
    </div>
  </div>
</ng-container>
